module.exports = __webpack_public_path__ + "static/media/picture-last-page.6b072d76.png";